import _ from 'lodash'
import moment from 'moment-timezone'
import React from 'react'
import { Button, Image, Modal, Segment } from 'semantic-ui-react'

import defaultAvatar from '../../assets/images/default-avatar.png'
import { tr } from '../../helpers/languages'
import { format } from '../../helpers/timezones'

const Note = (props) => {
    const days = [
        tr('MONDAYS'),
        tr('TUESDAYS'),
        tr('WEDNESDAYS'),
        tr('THURSDAYS'),
        tr('FRIDAYS'),
        tr('SATURDAYS'),
        tr('SUNDAYS')
    ]
    return (
        <Modal className='note' open onClose={(_e) => { props.onClose() }}>
            <Modal.Content>
                <Segment className='note-text'>
                    {tr('YOUR_CHANGES_HAVE_BEEN_SAVED_BUT_SESSIONS_WITH')}&nbsp;
                    {
                        /* eslint-disable react/no-array-index-key */
                        props.conflicts.map((conflict, index) => {
                            const now = moment()
                                .tz(props.timezone)
                            const day = conflict.weekday + 1
                            const today = now.isoWeekday()
                            let end
                            if (today <= day) {
                                end = now.isoWeekday(day)
                            } else {
                                end = now.add(1, 'weeks')
                                    .isoWeekday(day)
                            }
                            end = end.add(conflict.sessions_remaining - 1, 'weeks')
                            const separator = index === props.conflicts.length - 2 ? ' ' + tr('AND')
                                : index === props.conflicts.length - 1 ? '' : ','
                            return (
                                <div key={`detail${index}`}>
                                    <span className='emphasised'>{conflict.client_name}</span>
                                    <span> ({tr('ENDS')} {format(end, 'D MMMM', props.timezone, props.language)})</span>
                                    <span>{separator}&nbsp;</span>
                                </div>
                            )
                        })
                        /* eslint-enable react/no-array-index-key */
                    }
                    {tr('WILL_CONTINUE')}
                </Segment>
                <Segment className='note-conflicts'>
                    {
                        /* eslint-disable react/no-array-index-key */
                        props.conflicts.map((conflict, index) => {
                            return (
                                <Segment.Group
                                    key={`conflict${index}`}
                                    horizontal
                                    className={`conflict ${index === props.conflicts.length - 1 ? 'last' : ''}`}
                                >
                                    <Segment className='conflict-image'>
                                        <Image
                                            src={_.isEmpty(conflict.client_img) ? defaultAvatar : conflict.client_img}
                                            circular/>
                                    </Segment>
                                    <Segment className='conflict-name'>
                                        {conflict.client_name}
                                    </Segment>
                                    <Segment className='conflict-session'>
                                        {days[conflict.weekday]}<br/>{conflict.start}&nbsp;-&nbsp;{conflict.end}
                                    </Segment>
                                    <Segment className='conflict-remaining'>
                                        {conflict.sessions_remaining}&nbsp;
                                        {tr(conflict.sessions_remaining === 1 ? 'MORE_WEEK' : 'MORE_WEEKS')}
                                    </Segment>
                                </Segment.Group>
                            )
                        })
                        /* eslint-enable react/no-array-index-key */
                    }
                </Segment>
                <Segment className='note-buttons right aligned'>
                    <Button className='ok' onClick={(_e) => { props.onClose() }}>
                        {tr('OK')}
                    </Button>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default Note



// WEBPACK FOOTER //
// ./src/components/availability/note.js